export type PasswordCheck = {
    length: boolean;
    capitalAndLowerCase: boolean;
    number: boolean;
    sign: boolean;
};

export const isURL = (input: string) => {
    const urlPattern =
        /^(https?:\/\/www\.|https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)?$/;
    return urlPattern.test(input);
};

export const isEmail = (input: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
};

export const isPhoneNumber = (input: string) => {
    const phoneRegex = /^\+?\d{1,3}[- ]?\d{3,}$/;
    return phoneRegex.test(input);
};

export const checkPassword = (input: string): PasswordCheck => ({
    length: input.length >= 9,
    number: /\d/.test(input),
    capitalAndLowerCase: /[A-Z]/.test(input) && /[a-z]/.test(input),
    sign: /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(input)
});
